import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [roles, setRoles] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [modules, setModules] = useState([]);
    const [dataScopes, setDataScopes] = useState([]);
    const [moduleNames, setModuleNames] = useState([]);

    useEffect(() => {
        const userInfo = localStorage.getItem('user-info');
        if (userInfo) {
            const { user, roles, permissions, modules, module_names, data_scopes } = JSON.parse(userInfo);
            setUser(user);
            setRoles(roles);
            setPermissions(permissions);
            setModules(modules);
            setModuleNames(module_names);
            setDataScopes(data_scopes || []);
        }
    }, []);


    const handleLogin = (userData) => {
        setUser(userData.user);
        setRoles([...userData.roles]);
        setPermissions([...userData.permissions]);
        setModules([...userData.modules]);
        setModuleNames([...userData.module_names]);
        setDataScopes([...(userData.data_scopes || [])]);
        localStorage.setItem('user-info', JSON.stringify(userData));
    };

    const logout = () => {
        setUser(null);
        setRoles([]);
        setPermissions([]);
        setModules([]);
        setModuleNames([]);
        setDataScopes([]);
        localStorage.removeItem('user-info');
    };

    const updatePermissions = (newPermissions) => {
        const permissionNames = newPermissions.map((permission) => permission.name);
        setPermissions([...permissionNames]);

        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const updatedUserInfo = {
            ...userInfo,
            permissions: [...permissionNames], // Update localStorage
        };
        localStorage.setItem('user-info', JSON.stringify(updatedUserInfo));
    };

    return (
        <AuthContext.Provider value={{ user, roles, permissions, modules, moduleNames, dataScopes, handleLogin, logout, updatePermissions }}>
            {children}
        </AuthContext.Provider>
    );
};
